var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.103 0.172501V0H34.656V0.172501L34.641 0.17L32.2765 14.31H0V43.54H57.2105V42.0855H57.129L50.12 0.17L50.103 0.172501ZM41.631 14.31V42.0855H55.6545L50.1245 9.0145H34.6365L33.751 14.31H41.631ZM35.0375 23.5255V42.0855H40.1765V15.7645H1.454V42.0855H6.1695V23.5255H35.0375ZM25.8995 29.5665V42.0855H33.5835V29.5665H25.8995ZM16.7615 29.5665V42.0855H24.4455V29.5665H16.7615ZM7.624 29.5665V42.0855H15.3075V29.5665H7.624ZM7.624 24.9795V28.1125H15.3075V24.9795H7.624ZM16.7615 24.9795V28.1125H24.4455V24.9795H16.7615ZM25.8995 24.9795V28.1125H33.5835V24.9795H25.8995ZM48.8605 1.4545H35.901L34.88 7.5605H49.8815L48.8605 1.4545Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrial);
export default __webpack_public_path__ + "static/media/industrial.16e6ab508de104adc16e65ae8d40b649.svg";
export { ForwardRef as ReactComponent };